import installationInstructions from './installationInstructions';

const p158Content = {
  installationInstructions
}

export { p158Content };
